const UNI_LIST = 'https://tokens.uniswap.org'
// const AAVE_LIST = 'tokenlist.aave.eth' // Removed - ENS/IPFS resolution issues
const BA_LIST = 'https://raw.githubusercontent.com/The-Blockchain-Association/sec-notice-list/master/ba-sec-list.json'
// const CMC_ALL_LIST = 'https://api.coinmarketcap.com/data-api/v3/uniswap/all.json' // Removed - CORS errors
const COINGECKO_LIST = 'https://tokens.coingecko.com/uniswap/all.json'
const COMPOUND_LIST = 'https://raw.githubusercontent.com/compound-finance/token-list/master/compound.tokenlist.json'
const KIBASWAP_LIST = 'https://raw.githubusercontent.com/TheKibaInu/kibaswap_alpha/main/kibaswap-list.json'
export const ARBITRUM_LIST = 'https://bridge.arbitrum.io/token-list-42161.json'
// const KLEROS_LIST = 't2crtokens.eth' // Removed - ENS/IPFS resolution issues
export const OPTIMISM_LIST = 'https://static.optimism.io/optimism.tokenlist.json'
// const ROLL_LIST = 'https://app.tryroll.com/tokens.json' // Removed - service no longer exists
const SET_LIST = 'https://raw.githubusercontent.com/SetProtocol/uniswap-tokenlist/main/set.tokenlist.json'
// const WRAPPED_LIST = 'wrapped.tokensoft.eth' // Removed - ENS/IPFS resolution issues

export const UNSUPPORTED_LIST_URLS: string[] = [BA_LIST]

// this is the default list of lists that are exposed to users
// lower index == higher priority for token import
const DEFAULT_LIST_OF_LISTS_TO_DISPLAY: string[] = [
  UNI_LIST,
  COMPOUND_LIST,
  // AAVE_LIST, // Removed - ENS/IPFS resolution issues
  // CMC_ALL_LIST, // Removed - CORS errors
  COINGECKO_LIST,
  // KLEROS_LIST, // Removed - ENS/IPFS resolution issues
  KIBASWAP_LIST,
  // WRAPPED_LIST, // Removed - ENS/IPFS resolution issues
  SET_LIST,
  // ROLL_LIST, // Removed - service no longer exists
  ARBITRUM_LIST,
  OPTIMISM_LIST,
]

export const DEFAULT_LIST_OF_LISTS: string[] = [
  ...DEFAULT_LIST_OF_LISTS_TO_DISPLAY,
  ...UNSUPPORTED_LIST_URLS, // need to load dynamic unsupported tokens as well
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = [KIBASWAP_LIST]
